<template>
  <div>
    <el-button @click="dialogVisibles = true">查询员工历史KPI</el-button>
    <el-dialog
      :visible.sync="dialogVisibles"
      title="查询员工历史KPI"
      width="1000px"
      @close="closeDialog"
    >
      <div class="page-actions">
        <el-input v-model="userId" placeholder="请输入员工ID"></el-input>
        <el-button type="primary" @click="handleSave()">查询</el-button>
      </div>

      <el-table :data="historyList">
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kpi" label="kpi"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'CreateContent',
  data() {
    return {
      dialogVisibles: false,
      userId: ''
    };
  },
  components: {
    Editor
  },
  computed: {
    ...mapState('kpi', ['historyList'])
  },
  methods: {
    ...mapActions('kpi', ['seachHis']),
    closeDialog() {
      this.dialogVisibles = false;
    },
    handleSave() {
      if (!this.userId) {
        this.$message({
          message: '员工ID不能为空',
          type: 'error'
        });
        return;
      } else {
        this.seachHis({ userId: this.userId });
      }
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.el-button {
  margin-left: 15px;
}
</style>
